module.exports = __webpack_public_path__ + "files/deaf3cbbf0bc72ac8f31a4ae8ce4d449.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Exo-2-regular.woff
 ** module id = 854
 ** module chunks = 0
 **/